import Vue from 'vue'

const types = {
  SET_PAGER: 'SET_PAGER',
}

export const paginationActions = {
  setPager({ commit, getters }, { prop, value, pager = { ...getters.pager } }) {
    if (prop) {
      pager[prop] = value
    } else {
      pager = Object.assign(pager, value)
    }
    commit(types.SET_PAGER, { pager })
  },
}

export const paginationGetters = {
  pager: (state) => state.pager,
  limit: (state) => state.pager?.limit,
  offset: (state) => state.pager?.offset || 0,
  total: (state) => state.pager?.total,
}

export const paginationMutations = {
  [types.SET_PAGER](state, { pager }) {
    Vue.set(state, 'pager', pager)
  },
}
